import { Icon } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const CompleteLayout = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: var(--spacing-md, 12px);
  width: 100%;
  height: 100%;
  min-height: 0;
  padding: var(--spacing-lg, 16px) var(--spacing-xl, 24px);
  background: var(--color-gray-50, #f6f6f7);
  border-radius: var(--radius-md, 8px);
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm, 8px);
`;

export const SuccessIcon = styled(Icon)`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background-color: var(--color-green-600, #1e9b46);
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: var(--color-gray-950, #19191b);
`;

export const SubTitle = styled.p`
  margin: 0;
  max-width: 436px;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: var(--color-foreground, #404145);
`;

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg, 16px);
  width: 373px;
  max-width: 100%;
  padding: var(--spacing-lg, 16px);
  background: #ffffff;
  border: 1px solid var(--color-gray-100, #e2e3e5);
  border-radius: var(--radius-md, 8px);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--spacing-sm, 8px);
  width: 100%;
`;

export const RowLabel = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-gray-600, #4d4e54);
`;

export const RowValue = styled.span`
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #000000;
`;

/* Right-aligned value column for the licenses row (price + renewal subtext). */
export const LicenseValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const RenewSubtext = styled.span`
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  color: var(--color-gray-400, #7d7e84);
`;

export const TotalLabel = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
`;

export const TotalValue = styled.span`
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  color: #000000;
`;

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  margin: 0;
  border: 0;
  background: var(--color-gray-100, #e2e3e5);
`;

/* Device line ("x{n} {PIXI} device") — inline logo, matching the deal card. */
export const FreeDeviceLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex: 1 1 auto;
  min-width: 0;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--color-gray-600, #4d4e54);
`;

export const PixiInlineLogo = styled.img`
  display: inline-block;
  height: 11px;
  width: auto;
`;

export const CompleteButtonRow = styled.div`
  display: flex;
  justify-content: center;
  padding-top: var(--spacing-sm, 8px);
`;
